import { GAME_RULES } from "./util";

var isDev = /localhost:56\d{2}/.test(location.href);

const initNoviceGameTypeList = () => {
  $.ajax({
    type: "GET",
    url: `${isDev ? "/api" : ""}/web/rest/configs2`,
    error: function () {},
  }).done(({ result }) => {
    if (result?.["user.lotterys"]?.length) {
      const availableLotteries = result?.["user.lotterys"]?.map(({ id }) => id);
      const gameRulesContainer = $("<div class='novice-container'></div>");
      const gameRulesHeader = $("<div class='novice-container__header'></div>");
      const gameRulesBody = $("<div class='novice-container__body'></div>");
      const gameRulesList = $("<ul></ul>");

      GAME_RULES.forEach(({ subtitle, topics }) => {
        const firstAvailableGameRules = topics.find(({ hash }) => availableLotteries.includes(hash));

        if (firstAvailableGameRules && gameRulesList.children().length < 3) {
          const { hash } = firstAvailableGameRules;

          if (gameRulesList.children().length === 0) {
            gameRulesHeader.append(
              "<img src='img/icon-help-rules.png' />",
              "<p>游戏规则</p>",
              `<a href='./help-more-novice.html#${hash}' target='_self'><img src='img/icon-arrow.svg'/></a>`
            );
          }

          gameRulesList.append(
            `<li><a href='./help-more-novice.html#${hash}'>${
              gameRulesList.children().length === 2 ? "更多" : subtitle
            }</a></li>`
          );
        }
      });

      gameRulesBody.append(gameRulesList);
      gameRulesContainer.append(gameRulesHeader, gameRulesBody);
      $(".novice-section").append(gameRulesContainer);
    }
  });
};

const getFaqGuideList = () => {
  $.ajax({
    type: "GET",
    url: `${isDev ? "/api" : ""}/web/rest/faqs/getFaqGuideList`,
    error: function () {},
  }).done(({ result }) => {
    if (result.length > 0) {
      $("#tutorial-section-container").removeClass("hide");

      $(".tutorial-section").append(
        result.reduce((accTutorial, { imagePath, videoUrl, title }) => {
          if (accTutorial.length > 4) {
            return accTutorial;
          }

          return [
            ...accTutorial,
            `<div class="tutorial-container">
              <div class="tutorial-container__image-wrapper">
                <a href=${videoUrl} target="_blank">
                  <img src=${imagePath} />
                  <div class="tutorial-container__image-wrapper--overlay">
                    <img src="img/play.png" />
                  </div>
                </a>
              </div>
              <p>${title}</p>
            </div>
            `,
          ];
        }, [])
      );
    }
  });
};

$(function () {
  getFaqGuideList();

  const path = location.pathname.split("/").pop();
  const origin = location.origin;
  const currentHash = location.hash.slice(1);

  if (path === "help.html") {
    initNoviceGameTypeList();

    const iframe = $(".faq-content[data-hash='faq-recharge'] iframe");
    iframe[0].setAttribute("src", `${origin}/util/faq/dsn/faq-recharge.html`);

    if (currentHash) {
      const iframe = $(`.faq-content[data-hash='${currentHash}'] iframe`);
      iframe[0].setAttribute("src", `${origin}/util/faq/dsn/${currentHash}.html`);
    }
  }
});

$(".faq-section .faq-nav .faq-nav__nav-item").on("click", function () {
  $(this).addClass("active").siblings().removeClass("active");
  location.hash = $(this).attr("data-hash");
  const currrentTab = location.hash.slice(1);

  $(`.faq-content[data-hash="${currrentTab}"]`).addClass("active").siblings().removeClass("active");

  const origin = location.origin;
  const currentIframe = $(`.faq-content[data-hash="${currrentTab}"] iframe`);

  if (!currentIframe[0].getAttribute("src")) {
    currentIframe[0].setAttribute("src", `${origin}/util/faq/dsn/${currrentTab}.html`);
  }
});
